/**
 * `delay` is a function that can
 * be used to delay async tasks
 */
export const delay = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

/**
 * `timeout` is a function that
 * can be used to time out promises
 */
export const timeout = <T>(promise: Promise<T>, ms: number) => {
  let timeoutId: NodeJS.Timeout

  return Promise.race([
    promise,
    new Promise((_, reject) => {
      timeoutId = setTimeout(() => {
        reject(Error('timeout'))
      }, ms)
    }),
  ]).finally(() => {
    clearTimeout(timeoutId)
  })
}

/**
 * `retry` is function for retrying callback function
 * which return promise X(`retries`) times before rejecting
 */
export async function retry<T>(
  callback: (retryCount?: number) => Promise<T>,
  retries: number,
  retryCount = 0
): Promise<T> {
  try {
    return await callback(retryCount)
  } catch (error) {
    if (retryCount >= retries - 1) {
      return Promise.reject<T>(error)
    }
    // back-off delay
    await delay(Math.min(1000 * 2 ** retryCount, 30000))
    return retry(callback, retries, retryCount + 1)
  }
}
